import { render, staticRenderFns } from "./KiritoPage.vue?vue&type=template&id=6a54c921"
import script from "./KiritoPage.vue?vue&type=script&lang=js"
export * from "./KiritoPage.vue?vue&type=script&lang=js"
import style0 from "./KiritoPage.vue?vue&type=style&index=0&id=6a54c921&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports